import Vue from "../main.js"
import axios from 'axios'


// 创建axios实例
const service = axios.create({
    timeout: 1000 * 30,
    // 允许跨域带token
    withCredentials: true,
});

//设置post头请求
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// request拦截器
service.interceptors.request.use(
    (config) => {
        // 存储
        // localStorage.setItem("token", "74c8ffe4a59da108f03aa7afc77cc24e");
        // config.headers['token'] =localStorage.getItem("token")
        return config
    },
    (error) => {
        return Promise.reject(error)
    })

// response拦截器
service.interceptors.response.use(response => {
    if (response.data && response.data.code === 401) { // 401, token失效
        localStorage.removeItem("router");
        Vue.$router.push("/login");
    }
    return response
}, error => {
    Vue.$message({
        message: "请求出现异常！",
        duration: 1500,
        type: "error"
    })
    return Promise.reject(error)
})


export default service;
